export default __webpack_public_path__ + "static/invoice-detail-mockup-96d6cf0e190c26708fc9165888104265.svg";